export enum ServiceRequestFormStep {
  Suite = 0,
  Asset = 1,
  IssueType = 2,
  Category = 3,
  Faqs = 4,
  Question = 5,
  Details = 6,
  Review = 7,
}
